jQuery( function ( $ ) {
    'use strict';

    pma_position_information_boxes();

    jQuery( window ).resize(function() {
        pma_position_information_boxes();
    });
});

/**
 * Set up the negative margins for the information boxes to be overlayed over sections
 */
function pma_position_information_boxes() {
    // setting the viewport width
    let viewport = updateViewportDimensions();

    let home_introduction = jQuery( '#home-introduction-wrapper' );
    let information_boxes = jQuery( '#information-boxes' );
    let featured_content_first_headline  = jQuery( '#featured-content-section .headline' ).first();

    let information_boxes_height = information_boxes.outerHeight();
    let information_box_margins  = information_boxes_height / 2;
    // let information_box_margins  = 50;

    if( viewport.width >= 1200 ) {
        home_introduction.css('margin-bottom', '-' + information_box_margins + 'px');
        information_boxes.css('margin-bottom', '-' + information_box_margins + 'px');
        // information_boxes.css('margin-top', '-' + information_box_margins + 'px');
        // home_introduction.css('padding-bottom', information_box_margins + 'px');
        // featured_content_first_headline.css('padding-top', information_box_margins + 'px');
    } else {
        home_introduction.css('margin-bottom', '0');
        information_boxes.css('margin-bottom', '0');
    }
}